import { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'
import { QueryClient, QueryClientProvider } from '@tanstack/react-query'

import { App } from '@/App'
import { aplicarPreferenciasIniciais } from '@/features/reader/stores/accessibilityStore'
import '@/styles.css'
import '@/styles/editorial.css'
import '@/styles/palavras.css'
import { applyPublisherBrand } from '@/services/palavrasBrand'
import { resolveLoginContext } from '@/services/loginContext'

const queryClient = new QueryClient({
  defaultOptions: {
    queries: { staleTime: 30_000, refetchOnWindowFocus: false, retry: 1 },
  },
})

// ANTES do primeiro render: esperar o `GET /reader/preferences` faria quem
// escolheu tema escuro levar um flash de tela branca a cada abertura.
aplicarPreferenciasIniciais()
applyPublisherBrand(resolveLoginContext().tenantSlug)

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <QueryClientProvider client={queryClient}>
      <App />
    </QueryClientProvider>
  </StrictMode>,
)
